import Image from 'next/image'
import { Drawer, IconButton } from 'rsuite'
import { TbWorld } from 'react-icons/tb'
import BrandLogo from '@/components/shared/brandLogo'
import useTranslation from '@/hooks/useTranslation'
import style from './mobileHeader.module.scss'
import ChangeVehicleIcon from '@/components/themes/common/icons/changeVehicleIcon'

function SubaruMobileMenuDrawer({
  open,
  onClose,
  title,
  image,
  languageLabel,
  canSwitchLanguage,
  onChangeVehicle,
  onLanguageClick,
  returnToLandingPage,
  isOnline
}) {
  const t = useTranslation()

  return (
    <Drawer open={open} onClose={onClose} placement="left" size="xs" className={style.mobileMenuDrawer}>
      <Drawer.Header closeButton className={style.drawerHeader}>
        <Drawer.Title className={style.drawerTitle}>
          <BrandLogo
            brand="subaru"
            onClick={e => {
              returnToLandingPage(e, isOnline)
              onClose()
            }}
            height={36}
            width={120}
            className={style.mobileLogo}
          />
        </Drawer.Title>
      </Drawer.Header>
      <Drawer.Body className={style.drawerBody}>
        <div className={style.mobileMenuContent}>
          <div className={style.mobileMenuButtonRow}>
            <IconButton
              id="btn-changeVehicle-mobile"
              className={style.vehicleBtn}
              icon={<ChangeVehicleIcon />}
              size="md"
              appearance="ghost"
              onClick={onChangeVehicle}
            >
              {t('header_change_vehicle', 'Change Vehicle')}
            </IconButton>
            {canSwitchLanguage && (
              <IconButton
                id="btn-language-mobile-menu"
                className={style.languageBtn}
                icon={<TbWorld />}
                size="md"
                appearance="ghost"
                onClick={onLanguageClick}
              >
                {languageLabel}
              </IconButton>
            )}
          </div>
          <div className={style.mobileMenuTitle}>{title}</div>
          {image && (
            <div className={style.mobileMenuImageWrapper}>
              <Image src={image} alt="Model" height={145} width={240} className={style.mobileMenuImage} />
            </div>
          )}
        </div>
      </Drawer.Body>
    </Drawer>
  )
}

export default SubaruMobileMenuDrawer
